// extracted by mini-css-extract-plugin
export default {"popoverItem":"styles_popoverItem__7oKhG","folderIcon":"styles_folderIcon__5YmWR","trigger":"styles_trigger__4W2WF","active":"styles_active__3nivf"};